<template>
  <div
    style="
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
    "
  >
    <!--左侧导航-->

    <div class="loading">
      <div>
        <img src="../assets/image/loading.png" />
      </div>
    </div>

    <div class="box-left about">
      <!--  -->
      <div
        style="
          width: 220px;
          height: 80px;
          text-align: center;
          padding-top: 20px;
        "
        class="left-title"
      >
        <img
          src="../assets/login/changju.png"
          style="width: 60%; cursor: pointer"
        />
      </div>
      <el-input
        size="mini"
        style="width: 80%; margin-left: 10%"
        v-model="find"
        @input="find_data"
      ></el-input>
      <el-menu
        @select="select"
        size="mini"
        style="height: calc(100% - 200px); overflow-x: hidden"
        text-color="#fff"
      >
        <el-submenu
          v-for="(item, index) in list"
          :key="index + 'i'"
          :index="index + 1 + ''"
        >
          <template slot="title">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.name }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item
              v-for="(item2, index2) in item.nav"
              :key="index2 + 'u'"
              :index="index + 1 + '-' + (index2 + 1)"
              >{{ item2.name }}
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
      <!-- <div style="position: absolute; bottom: 74px; left: 10px">
        
      </div> -->
      <div>
        <el-button
          type="danger"
          size="mini"
          @click="setPassword"
          style="
            width: 200px;
            background-color: #2497ff;
            border-color: #2497ff;
            margin-left: 10px;
            margin-bottom: 5px;
          "
          >设置密码
        </el-button>

        <el-button
          type="danger"
          size="mini"
          @click="logout"
          style="width: 200px"
          >退出登录
        </el-button>
      </div>
    </div>
    <!--右边页面-->
    <div class="box-right" v-if="cardlist.length > 0" id="right_body">
      <!--右边主体内容-->
      <div class="right-bottonm" id="right">
        <!--        顶部菜单栏-->
        <el-tabs
          @edit="handleTabsEdit"
          @tab-click="handleTabschange"
          v-model="activeName"
          id="title_tab"
          style="height: 100%; left: 1px"
        >
          <el-tab-pane
            v-for="(item, index) in cardlist"
            :name="item.path"
            :label="item.name"
            :key="item.key"
            style="height: 100%"
          >
            <span slot="label" :id="'tab-' + index">
              {{ item.name }}&nbsp;&nbsp;<i
                class="el-icon-close"
                @click="close_one_tab(index)"
              ></i
            ></span>
            <compoment
              :path="item.path"
              :menudata="item"
              :is="nav_tab[item.path].default"
            ></compoment>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!--右边页面没有选择任何都东西情况-->
    <div class="box-right" v-else>
      <div class="loading">
        <div>
          <img style="margin-right: 300px" src="../assets/image/loading.png" />
        </div>
      </div>
      <!--右边主体内容-->
      <div class="right-bottonm" id="right">
        <bodyContent></bodyContent>
        <!--        <indexconcat></indexconcat>-->
      </div>
    </div>
    <!--  右键菜单-->
    <div :class="right_move_class" :style="right_move_style">
      <div class="right_menu_item" @click="reload_one">
        &nbsp;&nbsp;&nbsp;&nbsp;刷新&nbsp;
      </div>
      <div class="right_menu_item" @click="close_one">
        &nbsp;&nbsp;&nbsp;&nbsp;关闭&nbsp;
      </div>
      <div class="right_menu_item" @click="close_other">
        &nbsp;&nbsp;&nbsp;&nbsp;关闭其他&nbsp;
      </div>
      <div class="right_menu_item" @click="close_all">
        &nbsp;&nbsp;&nbsp;&nbsp;关闭所有&nbsp;
      </div>
      <div class="right_menu_item" @click="move_left">
        &nbsp;&nbsp;&nbsp;&nbsp;移到最左侧&nbsp;&nbsp;&nbsp;&nbsp;
      </div>
    </div>

    <el-dialog
      title="设置密码"
      :visible.sync="showPasswordDialog"
      width="30%"
      :before-close="
        () => {
          showPasswordDialog = false;
        }
      "
    >
      <el-form :model="passwordForm" label-width="100px">
        <el-form-item label="新密码">
          <el-input
            v-model="passwordForm.password"
            type="password"
            placeholder="请输入新密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input
            v-model="passwordForm.confirmPassword"
            type="password"
            placeholder="请再次输入密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPasswordDialog = false">取 消</el-button>
        <el-button type="primary" @click="confirmPassword">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import u from "../assets/js/util.js";
// 房型/产品排序
import bodyContent from "@/components/home/bodyContent.vue";
var wsserin;
var vm;
//组件填写
var select_tap = "";
export default {
  components: this.nav_tab,
  components: {
    
    bodyContent
  },
  data() {
    return {
      showPasswordDialog: false,
      passwordForm: {
        password: "",
        confirmPassword: "",
      },
      find: "",
      move_index: 0,
      nav_tab: {},
      cardlist: [],
      right_move_class: "right_menu",
      right_move_style: "",
      activeName: "",
      title_name: "",
      select_name: "",
      select_path: "", //默认打开页面
      list: [],
      re_list: [],
    };
  },
  name: "indexhome",
  async mounted() {
    vm = this;
    var userinfo = await u.post("users", "getuserinfo", {});
    // console.log(userinfo,);
    window.userinfo = userinfo;
    var _this = this;
    if (userinfo.nav) {
      this.list = userinfo.nav;
      this.re_list = userinfo.nav;
      //动态添加组件
      for (var i = 0; i < userinfo.nav.length; i++) {
        if (userinfo.nav) {
          var item = userinfo.nav[i];
          for (var j = 0; j < item.nav.length; j++) {
            await this.setmodus(item.nav[j].path, item.nav[j].url);
          }
        }
      }
    }
    window.onkeydown = (event) => {
      if (!event || !event.isTrusted || !event.cancelable) {
        return;
      }
      const key = event.key;
      if (key === "F5") {
        if (_this.cardlist.length != 0) {
          for (var i = 0; i < _this.cardlist.length; i++) {
            if (_this.cardlist[i].path == _this.activeName) {
              _this.cardlist[i].key = _this.activeName + Math.random();
            }
          }
          event.preventDefault();
          event.returnValue = false;
        }
      }
    };

    document.title =
      u.config().proth == 1
        ? "酒管系统服务商平台"
        : u.config().proth == 4
        ? "酒店系统管理平台"
        : "酒管系统代理商作业平台";
  },
  methods: {
    // ... existing methods ...
    async setPassword() {
      this.showPasswordDialog = true;
    },
    async confirmPassword() {
      const strongPasswordRegex =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/;
      // 判断密码是否很复杂哦
      if (!this.passwordForm.password) {
        this.$message.error("密码不能为空");
        return;
      }
      if (this.passwordForm.password.length < 6) {
        this.$message.error("密码长度不能少于6位");
        return;
      }
      if (!strongPasswordRegex.test(this.passwordForm.password)) {
        this.$message.error("密码必须包含大小写字母和数字");
        return;
      }
      if (this.passwordForm.password !== this.passwordForm.confirmPassword) {
        this.$message.error("两次输入的密码不一致");
        return;
      }

      const result = await u.post("users", "settingpws", {
        pwd: this.passwordForm.password,
      });
      console.log(result, "resultresult");
      if (result !== false) {
        this.$message.success("密码设置成功");
        this.showPasswordDialog = false;
        delCookie("AUTH");
        this.$router.push("/login");
        this.passwordForm = {
          password: "",
          confirmPassword: "",
        };
      } else {
        this.$message.error("密码设置失败");
      }
    },
    /**
     * 根据后端设置配置前端组件
     * @param path
     * @param url
     * @returns {Promise<unknown>}
     */
    setmodus(path, url) {
      var _this = this;
      return new Promise((r, e) => {
        import("./module/" + url).then((data) => {
          _this.nav_tab[path] = data;
          r();
        });
      });
    },
    logout() {
      this.$confirm("确认退出登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delCookie("AUTH");
          this.$router.push("/login");
        })
        .catch(() => {});
    },
    // 搜索一级菜单
    find_data(e) {
      var linshilist = [];
      this.re_list.forEach((item) => {
        if (item.name.indexOf(e) != -1) {
          linshilist.push(item);
        }
      });
      this.list = linshilist;
    },
    //关闭全部
    close_all(e) {
      this.cardlist = [];
    },
    //移动到左侧
    move_left(e) {
      var one = this.cardlist[select_tap];
      this.cardlist.splice(select_tap, 1);
      this.cardlist.unshift(one);
    }, //关闭其他
    close_other(e) {
      this.cardlist = [this.cardlist[select_tap]];
    }, //刷新
    reload_one(e) {
      this.cardlist[select_tap].key = Math.random().toString();
    },
    close_one_tab(index) {
      var select_tap = index;
      this.cardlist.splice(select_tap, 1);
      if (select_tap > 0) {
        this.activeName = this.cardlist[select_tap - 1].path;
        window.select_path = this.cardlist[select_tap - 1].path;
        setcokiedata(this.cardlist[select_tap - 1]);
      } else {
        if (this.cardlist.length > 0) {
          this.activeName = this.cardlist[select_tap].path;
          window.select_path = this.cardlist[select_tap].path;
          setcokiedata(this.cardlist[select_tap]);
        }
      }
      if (select_tap > 0) {
        this.select_name = this.cardlist[select_tap - 1].name;
        this.select_path = this.cardlist[select_tap - 1].path;
        window.select_path = this.select_path;
        this.activeName = this.cardlist[select_tap - 1].path;
        setcokiedata(this.cardlist[select_tap - 1]);
      } else {
        setcokiedata();
      }
    },
    //关闭当前
    close_one(e) {
      this.cardlist.splice(select_tap, 1);
      if (select_tap > 0) {
        this.activeName = this.cardlist[select_tap - 1].path;
        window.select_path = this.cardlist[select_tap - 1].path;
        setcokiedata(this.cardlist[select_tap - 1]);
      } else {
        if (this.cardlist.length > 0) {
          this.activeName = this.cardlist[select_tap].path;
          window.select_path = this.cardlist[select_tap].path;
          setcokiedata(this.cardlist[select_tap]);
        }
      }
      if (select_tap > 0) {
        this.select_name = this.cardlist[select_tap - 1].name;
        this.select_path = this.cardlist[select_tap - 1].path;
        window.select_path = this.select_path;
        this.activeName = this.cardlist[select_tap - 1].path;
        setcokiedata(this.cardlist[select_tap - 1]);
      } else {
        setcokiedata();
      }
    },
    handleTabschange(e, event) {
      window.select_path = this.cardlist[e.index].path;
      setcokiedata(this.cardlist[e.index]);
    },
    handleTabsEdit(e) {
      for (var i = 0; i < this.cardlist.length; i++) {
        if (this.cardlist[i].path == e) {
          this.cardlist.splice(i, 1);
          if (i > 0) {
            this.select_name = this.cardlist[i - 1].name;
            this.select_path = this.cardlist[i - 1].path;
            window.select_path = this.select_path;
            this.activeName = this.cardlist[i - 1].path;
            setcokiedata(this.cardlist[i - 1]);
          }
          break;
        }
      }
    },
    // 点击菜单栏
    select(data) {
      var sum = data.split("-");
      this.title_name = this.list[Number(sum[0]) - 1].name;
      var select = this.list[Number(sum[0]) - 1].nav[Number(sum[1]) - 1];
      for (var i = 0; i < this.cardlist.length; i++) {
        if (this.cardlist[i].path == select.path) {
          this.activeName = select.path;
          setcokiedata(select);
          return;
        }
      }
      setcokiedata(select);
      this.select_name = select.name;
      this.select_path = select.path;
      window.select_path = this.select_path;
      var carddata = select;
      this.$set(carddata, "key", select.path + Math.random().toString());
      this.cardlist.push(carddata);
      this.activeName = select.path;
    },
  },
};

function setcokiedata(obj) {
  if (!obj) {
    u.setCookie("module", "public");
    u.setCookie("server", "public");
    u.setCookie("identifying", "");
  } else {
    u.setCookie("module", obj.module);
    u.setCookie("table_name", obj.name);
    u.setCookie("server", obj.server);
    u.setCookie("identifying", obj._id);
  }
}

document.onclick = function (e) {
  if (vm && vm.right_move_class) {
    vm.right_move_class = "right_menu";
  }
};
document.oncontextmenu = function (e) {
  var id = e.target.id;
  if (!id) {
    return;
  }
  select_tap = Number(id.split("-")[1]);
  if (id.indexOf("tab-") != -1) {
    vm.right_move_class = "right_menu right_menu_active";
    vm.right_move_style = `left:${e.pageX}px;top:${e.pageY}px;z-index:999`;
    e.stopPropagation();
    return false;
  } else {
    vm.right_move_class = "right_menu";
  }
}; //禁止鼠标右键菜单显示
function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}

function getCookie(name) {
  let arr = document.cookie.match(new RegExp("(^| )" + name + "=([^;]*)(;|$)"));
  if (arr != null) return unescape(arr[2]);
  return null;
}
</script>

<style scoped>
.right_menu {
  display: none;
  padding: 3px 0px;
  font-size: 14px;
  border-radius: 5px;
  border: solid 1px #efefef;
  background-color: #ffffff;
  position: absolute;
}

.right_menu_active {
  display: block;
}

.right_menu_item {
  padding: 5px 0px;
  cursor: default;
}

.right_menu_item:hover {
  background-color: #efefef;
  cursor: pointer;
}

.box-left {
  width: 220px;
  height: 100%;
  background-color: #00152a;
}

.box-right {
  width: 100% !important;
  padding: 0 !important;
  /*width: calc(100% - 210px);*/
  /*background-color: #efefef;*/
  /*background-size: 100% 100%;*/
  /*background-repeat: no-repeat;*/
}

.right-bottonm {
  /*height: calc(100% - 46px);*/
  margin: 0 auto;
  border-radius: 1px;
  /*width: 99%;*/
}

.left-title {
  /*background-image: url("../../assets/logo.png");*/
  /*background-size: 100% 100%;*/
}

.about >>> .el-menu-item:hover {
}

.about >>> .el-submenu__title:hover {
}

.about >>> .el-menu::-webkit-scrollbar {
  width: 3px;
  height: 3px;
}

.about >>> .el-menu {
  border-right: solid 0px #e6e6e6 !important;
}

.box-right >>> .el-tabs__header {
  padding: 0;
  margin: 0;
}

.box-right >>> .el-tabs__active-bar {
  display: none;
}

.box-right >>> .el-tabs__item {
  padding: 0px 10px;
  border-radius: 4px;
  user-select: none;
  height: 30px;
  line-height: 30px;
  margin: 5px 2px;
}

.box-right >>> .el-tabs--top .el-tabs__item.is-top:last-child {
  padding: 0px 10px;
  border-radius: 4px;
  user-select: none;
  margin: 5px 2px;
}

.box-right >>> .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
  padding: 0px 10px;
  border-radius: 4px;
  user-select: none;
  margin: 5px 2px;
}

.box-right >>> .tab-customer {
  user-select: none;
}

.box-right >>> .el-tabs__content {
  height: 100%;
  position: absolute;
  width: calc(100% - 220px);
  height: calc(100% - 40px);
}

.box-right >>> .el-tabs__nav-wrap::after {
  height: 0px;
}

.box-right >>> .el-tabs__nav-scroll {
  background-color: #00152a;
}

.box-right >>> .el-tabs__item {
  color: #ffffff;
}

.box-left >>> .el-menu-item .is-active {
  background-color: #ffffff !important;
}

.box-right >>> .is-active span {
  padding: 4px 7px !important;
  background: rgb(33, 116, 255, 0.5) !important;
  border-radius: 4px !important;
}

.box-right >>> .el-tabs__item .el-icon-close {
  margin-left: 0 !important;
}

.box-left >>> .el-menu {
  background-color: #00152a !important;
}

.box-left >>> .el-menu-item:hover {
  background-color: rgba(33, 116, 255, 0.4) !important;
}

.box-left >>> li .is-active {
  color: #ffffff !important;
  background-color: #2174ff !important;
}

.box-left >>> .is-active span {
  color: #ffffff !important;
}

.box-left >>> .el-submenu__title {
  background-color: #00152a !important;
}

.box-left >>> .el-submenu__title {
  background-color: #00152a;
}

.loading {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 99999;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: rgba(100, 100, 100, 0.3);
  display: none;
}

.loading img {
  -webkit-animation: rotate 1s linear infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    /* IE 9 */
    -moz-transform: rotate(0deg);
    /* Firefox */
    -o-transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    /* IE 9 */
    -moz-transform: rotate(360deg);
    /* Firefox */
    -o-transform: rotate(360deg);
  }
}

@-webkit-keyframes rotate {
  0% {
    -moz-transform: rotate(0deg);
  }

  100% {
    -moz-transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/page/index.vue